import React from "react";
import "./Schedule.scss";

const LOCATIONS = [
  { key: "plavnieki", name: "Pļavnieki" },
  { key: "imanta",    name: "Imanta" },
  { key: "jurmala",   name: "Jūrmala" },
];

const WEEK = [
  { key: "mon", name: "Pirmdiena" },
  { key: "tue", name: "Otrdiena" },
  { key: "wed", name: "Trešdiena" },
  { key: "thu", name: "Ceturtdiena" },
  { key: "fri", name: "Piektdiena" },
  { key: "sat", name: "Sestdiena" },
  { key: "sun", name: "Svētdiena" },
];

// Базовые времена — можно переопределять по локации/дню при необходимости
const TIMES = { kids: "16:30–18:00", teensAdults: "18:00–20:00" };

// Если какие-то дни/локации отличаются — задавай тут, иначе берутся TIMES
// пример: overrides["sat"]["jurmala"] = { kids: "11:00–12:30", teensAdults: "12:30–14:30" }
const overrides = {
  // sat: { jurmala: { kids: "11:00–12:30", teensAdults: "12:30–14:30" } },
};

export default function Schedule() {
  return (
    <section id="schedule" className="section schedule-section">
      <div className="container">
        <header className="section__head">
          <h2>Grafiks pēc lokācijām</h2>
          <p className="muted">Bērni: {TIMES.kids} · Jaunieši &amp; Pieaugušie: {TIMES.teensAdults}</p>
        </header>

        {/* Таблица для десктопа, на телефоне разваливается на карточки */}
        <div className="schedule">
          <div className="schedule__head">
            <div className="schedule__cell schedule__cell--head">Diena</div>
            {LOCATIONS.map((loc) => (
              <div key={loc.key} className="schedule__cell schedule__cell--head">
                {loc.name}
              </div>
            ))}
          </div>

          {WEEK.map((d) => (
            <div key={d.key} className="schedule__row">
              <div className="schedule__cell schedule__day">
                <div className="schedule__dayname">{d.name}</div>
              </div>

              {LOCATIONS.map((loc) => {
                const ov = overrides[d.key]?.[loc.key];
                const t = ov || TIMES;
                return (
                  <div key={loc.key} className="schedule__cell schedule__slot" data-loc={loc.name} aria-label={`${d.name} — ${loc.name}`}>
                    <div className="slot">
                      <div className="slot__line">
                        <span className="slot__label">Bērni</span>
                        <span className="slot__time">{t.kids}</span>
                      </div>
                      <div className="slot__line">
                        <span className="slot__label">Jaunieši &amp; Pieaugušie</span>
                        <span className="slot__time">{t.teensAdults}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>

        <p className="muted note">
          * Ja kādā dienā nodarbību nav — ieliec <code>null</code> atbilstošajam lauciņam iekš <code>overrides</code>,
          un šūna tiks parādīta kā “—”.
        </p>
      </div>
    </section>
  );
}
